export type BrokerNerdsBarkerCoreEnumsPricingMode = (typeof BrokerNerdsBarkerCoreEnumsPricingMode)[keyof typeof BrokerNerdsBarkerCoreEnumsPricingMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsPricingMode = {
  Individual: 'Individual',
  Staged: 'Staged',
} as const;
